function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN":
    case "REGISTER":
      return action.token;
    case "LOGOUT":
      return "";
    default:
      return state;
  }
}

function appStateReducer(state, action) {
  switch (action.type) {
    case "SET_APP_TRUE":
      return true;
    case "SET_APP_FALSE":
      return false;
    default:
      return state;
  }
}


export default function appReducer(state, action) {
  return {
    user: userReducer(state.user, action),
    appState: appStateReducer(state.appState, action),
  };
}